import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import cx from 'classnames';
import PropTypes from 'prop-types';

const AudioBody = ({ data, isEditMode }) => {
  let url = data?.url;
  let itemType = '';
  let directDownloadLink = '';

  if (Array.isArray(url)) {
    const selectedItem = url[0];
    itemType = selectedItem?.['@type'] || '';
    directDownloadLink =
      selectedItem?.audio_file?.download || selectedItem?.file?.download;
    url =
      selectedItem?.['@id'] ||
      selectedItem?.url ||
      selectedItem?.href ||
      selectedItem;
  }

  if (typeof url === 'object' && url !== null) {
    itemType = url['@type'] || '';
    directDownloadLink = url?.audio_file?.download || url?.file?.download;
    url = url['@id'] || url['url'] || url['href'];
  }

  const classes = cx('br-audio', 'my-md');

  let finalAudioSrc = directDownloadLink || url;

  if (!finalAudioSrc || typeof finalAudioSrc !== 'string') {
    return isEditMode ? (
      <div
        className="br-audio placeholder"
        style={{
          border: '1px dashed #ccc',
          padding: '10px',
          textAlign: 'center',
        }}
      >
        Por favor, selecione um arquivo de áudio na barra lateral.
      </div>
    ) : null;
  }

  finalAudioSrc = flattenToAppURL(finalAudioSrc);

  if (
    !directDownloadLink &&
    isInternalURL(finalAudioSrc) &&
    !finalAudioSrc.includes('@@download')
  ) {
    const baseUrl = finalAudioSrc.replace(/\/$/, '');
    const downloadField = itemType === 'File' ? 'file' : 'audio_file';
    finalAudioSrc = `${baseUrl}/@@download/${downloadField}`;
  }

  if (
    isInternalURL(finalAudioSrc) &&
    config.settings.prefixPath &&
    !finalAudioSrc.startsWith(config.settings.prefixPath)
  ) {
    finalAudioSrc = `${config.settings.prefixPath}${finalAudioSrc}`;
  }

  return (
    <div className={classes}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio controls src={finalAudioSrc}>
        Seu navegador não suporta o elemento de áudio.
      </audio>
    </div>
  );
};

AudioBody.propTypes = {
  isEditMode: PropTypes.bool,
  data: PropTypes.shape({
    url: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object,
    ]),
  }),
};

export default AudioBody;
